/* chnl v1.2.0 by Vitaliy Potapov @preserve */
"use strict";

function _typeof(e) {
  return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
    return typeof e;
  } : function (e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  })(e);
}

function _classCallCheck(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}

function _defineProperties(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}

function _createClass(e, t, n) {
  return t && _defineProperties(e.prototype, t), n && _defineProperties(e, n), e;
}

function _inherits(e, t) {
  if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), t && _setPrototypeOf(e, t);
}

function _getPrototypeOf(e) {
  return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}

function _setPrototypeOf(e, t) {
  return (_setPrototypeOf = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _possibleConstructorReturn(e, t) {
  return !t || "object" != typeof t && "function" != typeof t ? _assertThisInitialized(e) : t;
}

function _createSuper(r) {
  var i = _isNativeReflectConstruct();

  return function () {
    var e,
        t = _getPrototypeOf(r);

    if (i) {
      var n = _getPrototypeOf(this).constructor;

      e = Reflect.construct(t, arguments, n);
    } else e = t.apply(this, arguments);

    return _possibleConstructorReturn(this, e);
  };
}

function _toConsumableArray(e) {
  return _arrayWithoutHoles(e) || _iterableToArray(e) || _unsupportedIterableToArray(e) || _nonIterableSpread();
}

function _arrayWithoutHoles(e) {
  if (Array.isArray(e)) return _arrayLikeToArray(e);
}

function _iterableToArray(e) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) return Array.from(e);
}

function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _arrayLikeToArray(e, t) : void 0;
  }
}

function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var n = 0, r = new Array(t); n < t; n++) {
    r[n] = e[n];
  }

  return r;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var Channel = function () {
  function c(e) {
    _classCallCheck(this, c), this._listeners = [], this._mute = !1, this._accumulate = !1, this._accumulatedEvents = [], this._name = e || "", this._onListenerAdded = null, this._onFirstListenerAdded = null, this._onListenerRemoved = null, this._onLastListenerRemoved = null;
  }

  return _createClass(c, [{
    key: "addListener",
    value: function value(e, t) {
      this._pushListener(e, t, !1);
    }
  }, {
    key: "addOnceListener",
    value: function value(e, t) {
      this._pushListener(e, t, !0);
    }
  }, {
    key: "removeListener",
    value: function value(e, t) {
      this._ensureListener(e);

      var n = this._indexOfListener(e, t);

      0 <= n && this._spliceListener(n);
    }
  }, {
    key: "removeAllListeners",
    value: function value() {
      for (; this.hasListeners();) {
        this._spliceListener(0);
      }
    }
  }, {
    key: "hasListener",
    value: function value(e, t) {
      return this._ensureListener(e), 0 <= this._indexOfListener(e, t);
    }
  }, {
    key: "hasListeners",
    value: function value() {
      return 0 < this._listeners.length;
    }
  }, {
    key: "dispatch",
    value: function value() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      this._invokeListeners({
        args: t,
        async: !1
      });
    }
  }, {
    key: "dispatchAsync",
    value: function value() {
      for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
        t[n] = arguments[n];
      }

      this._invokeListeners({
        args: t,
        async: !0
      });
    }
  }, {
    key: "mute",
    value: function value(e) {
      var t = 0 < arguments.length && void 0 !== e ? e : {};
      this._mute = !0, t.accumulate ? this._accumulate = !0 : (this._accumulate = !1, this._accumulatedEvents = []);
    }
  }, {
    key: "unmute",
    value: function value() {
      this._mute = !1, this._accumulate && (this._dispatchAccumulated(), this._accumulate = !1);
    }
  }, {
    key: "_invokeListeners",
    value: function value(e) {
      var t = this,
          n = 0 < arguments.length && void 0 !== e ? e : {
        args: [],
        async: !1
      };
      this._mute ? this._accumulate && this._accumulatedEvents.push(n) : this._listeners.slice().forEach(function (e) {
        t._invokeListener(e, n), e.once && t.removeListener(e.callback, e.context);
      });
    }
  }, {
    key: "_invokeListener",
    value: function value(e, t) {
      var n,
          r,
          i = e.callback instanceof c;
      t.async ? i ? (n = e.callback).dispatchAsync.apply(n, _toConsumableArray(t.args)) : setTimeout(function () {
        return e.callback.apply(e.context, t.args);
      }, 0) : i ? (r = e.callback).dispatch.apply(r, _toConsumableArray(t.args)) : e.callback.apply(e.context, t.args);
    }
  }, {
    key: "_ensureListener",
    value: function value(e) {
      if (!c.isValidListener(e)) throw new Error("Channel " + this._name + ": listener is not a function and not a Channel");
    }
  }, {
    key: "_dispatchInnerAddEvents",
    value: function value() {
      var e, t;
      this._onListenerAdded && (e = this._onListenerAdded).dispatch.apply(e, arguments);
      this._onFirstListenerAdded && 1 === this._listeners.length && (t = this._onFirstListenerAdded).dispatch.apply(t, arguments);
    }
  }, {
    key: "_dispatchInnerRemoveEvents",
    value: function value() {
      var e, t;
      this._onListenerRemoved && (e = this._onListenerRemoved).dispatch.apply(e, arguments);
      this._onLastListenerRemoved && 0 === this._listeners.length && (t = this._onLastListenerRemoved).dispatch.apply(t, arguments);
    }
  }, {
    key: "_indexOfListener",
    value: function value(e, t) {
      for (var n = 0; n < this._listeners.length; n++) {
        var r = this._listeners[n],
            i = r.callback === e,
            s = e instanceof c,
            o = void 0 === t && void 0 === r.context,
            a = t === r.context;
        if (i && (s || o || a)) return n;
      }
    }
  }, {
    key: "_dispatchAccumulated",
    value: function value() {
      var t = this;
      this._accumulatedEvents.forEach(function (e) {
        return t._invokeListeners(e);
      }), this._accumulatedEvents = [];
    }
  }, {
    key: "_pushListener",
    value: function value(e, t, n) {
      this._ensureListener(e), this._checkForDuplicates(e, t), this._listeners.push({
        callback: e,
        context: t,
        once: n
      }), this._dispatchInnerAddEvents(e, t, n);
    }
  }, {
    key: "_checkForDuplicates",
    value: function value(e, t) {
      if (this.hasListener(e, t)) throw new Error("Channel " + this._name + ": duplicating listeners");
    }
  }, {
    key: "_spliceListener",
    value: function value(e) {
      var t = this._listeners[e],
          n = t.callback,
          r = t.context,
          i = t.once;
      this._listeners.splice(e, 1), this._dispatchInnerRemoveEvents(n, r, i);
    }
  }, {
    key: "onListenerAdded",
    get: function get() {
      return this._onListenerAdded || (this._onListenerAdded = new c("".concat(this._name, ":onListenerAdded"))), this._onListenerAdded;
    }
  }, {
    key: "onFirstListenerAdded",
    get: function get() {
      return this._onFirstListenerAdded || (this._onFirstListenerAdded = new c("".concat(this._name, ":onFirstListenerAdded"))), this._onFirstListenerAdded;
    }
  }, {
    key: "onListenerRemoved",
    get: function get() {
      return this._onListenerRemoved || (this._onListenerRemoved = new c("".concat(this._name, ":onListenerRemoved"))), this._onListenerRemoved;
    }
  }, {
    key: "onLastListenerRemoved",
    get: function get() {
      return this._onLastListenerRemoved || (this._onLastListenerRemoved = new c("".concat(this._name, ":onLastListenerRemoved"))), this._onLastListenerRemoved;
    }
  }], [{
    key: "isValidListener",
    value: function value(e) {
      return "function" == typeof e || e instanceof c;
    }
  }]), c;
}(),
    EventEmitter = function () {
  function e() {
    _classCallCheck(this, e), this._channels = new Map();
  }

  return _createClass(e, [{
    key: "addListener",
    value: function value(e, t, n) {
      this._getChannel(e).addListener(t, n);
    }
  }, {
    key: "on",
    value: function value(e, t, n) {
      this.addListener(e, t, n);
    }
  }, {
    key: "addOnceListener",
    value: function value(e, t, n) {
      this._getChannel(e).addOnceListener(t, n);
    }
  }, {
    key: "once",
    value: function value(e, t, n) {
      this.addOnceListener(e, t, n);
    }
  }, {
    key: "removeListener",
    value: function value(e, t, n) {
      this._getChannel(e).removeListener(t, n);
    }
  }, {
    key: "off",
    value: function value(e, t, n) {
      this.removeListener(e, t, n);
    }
  }, {
    key: "hasListener",
    value: function value(e, t, n) {
      return this._getChannel(e).hasListener(t, n);
    }
  }, {
    key: "has",
    value: function value(e, t, n) {
      return this.hasListener(e, t, n);
    }
  }, {
    key: "hasListeners",
    value: function value(e) {
      return this._getChannel(e).hasListeners();
    }
  }, {
    key: "dispatch",
    value: function value(e) {
      for (var t, n = arguments.length, r = new Array(1 < n ? n - 1 : 0), i = 1; i < n; i++) {
        r[i - 1] = arguments[i];
      }

      (t = this._getChannel(e)).dispatch.apply(t, r);
    }
  }, {
    key: "emit",
    value: function value(e) {
      for (var t = arguments.length, n = new Array(1 < t ? t - 1 : 0), r = 1; r < t; r++) {
        n[r - 1] = arguments[r];
      }

      this.dispatch.apply(this, [e].concat(n));
    }
  }, {
    key: "_getChannel",
    value: function value(e) {
      return this._channels.has(e) || this._channels.set(e, new Channel(e)), this._channels.get(e);
    }
  }]), e;
}(),
    SubscriptionItem = function () {
  function t(e) {
    _classCallCheck(this, t), this._params = e, this._isOn = !1, this._assertParams();
  }

  return _createClass(t, [{
    key: "on",
    value: function value() {
      if (!this._isOn) {
        var e = this._params.channel,
            t = e.addListener || e.addEventListener || e.on;
        this._applyMethod(t), this._isOn = !0;
      }
    }
  }, {
    key: "off",
    value: function value() {
      if (this._isOn) {
        var e = this._params.channel,
            t = e.removeListener || e.removeEventListener || e.off;
        this._applyMethod(t), this._isOn = !1;
      }
    }
  }, {
    key: "_applyMethod",
    value: function value(e) {
      var t = this._params,
          n = t.channel,
          r = t.event,
          i = t.listener,
          s = r ? [r, i] : [i];
      e.apply(n, s);
    }
  }, {
    key: "_assertParams",
    value: function value() {
      var e = this._params,
          t = e.channel,
          n = e.event,
          r = e.listener;
      if (!t || "object" !== _typeof(t)) throw new Error("Channel should be object");
      if (n && "string" != typeof n) throw new Error("Event should be string");
      if (!r || !Channel.isValidListener(r)) throw new Error("Listener should be function or Channel");
    }
  }]), t;
}(),
    Subscription = function () {
  function t(e) {
    _classCallCheck(this, t), this._items = e.map(function (e) {
      return new SubscriptionItem(e);
    });
  }

  return _createClass(t, [{
    key: "on",
    value: function value() {
      return this._items.forEach(function (e) {
        return e.on();
      }), this;
    }
  }, {
    key: "off",
    value: function value() {
      return this._items.forEach(function (e) {
        return e.off();
      }), this;
    }
  }]), t;
}(),
    ReactSubscription = function () {
  _inherits(i, Subscription);

  var r = _createSuper(i);

  function i(e, t) {
    var n;
    return _classCallCheck(this, i), (n = r.call(this, t))._overrideComponentCallback(e, "componentDidMount", "on"), n._overrideComponentCallback(e, "componentWillUnmount", "off"), n;
  }

  return _createClass(i, [{
    key: "_overrideComponentCallback",
    value: function value(r, e, i) {
      var s = this,
          o = r[e];

      r[e] = function () {
        if (s[i](), "function" == typeof o) {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) {
            t[n] = arguments[n];
          }

          return o.apply(r, t);
        }
      };
    }
  }]), i;
}(),
    chnl = Channel;

chnl.EventEmitter = EventEmitter, chnl.Subscription = Subscription, chnl.ReactSubscription = ReactSubscription, module.exports = chnl;